/**
 * @file Selfie Swap container.
 */

import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import { MeWithIdentities } from '../../graphql/queries/account';
import SelfieSwap from '../../components/selfie-swap/SelfieSwap';
import { openModal } from '../../../../actions/modal-actions';

const withUserData = graphql(MeWithIdentities, {
  options: () => ({
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data: { me, loading } }) => ({
    accountId: me?.id,
    identities: me?.linked_identities.records,
    loading,
  }),
});

const mapDispatchToProps = {
  openModal,
};

export default compose(
  withRouter,
  withUserData,
  connect(null, mapDispatchToProps),
)(SelfieSwap);
